module.exports = __webpack_public_path__ + "img/glm_gbt6184_2000.prt.0d14cb0b.jpg";